import _ from 'lodash';
import type { CopiedStudyQuery, CopiedStudyQueryVariables } from '@/shared/api';

import { createClient } from '@/shared/api';
import COPIED_STUDY_QUERY from '../queries/copiedStudy';

/**
 * Loads the source study used to prefill a copied study form. Runs COPIED_STUDY_QUERY for the id and throws the first GraphQL error message when the study field is nil.
 *
 * @param id - Identifier of the study being copied.
 * @returns The study record to copy from.
 */
const fetchCopiedStudy = async (id: any) => {
  const client = createClient();
  const copiedStudyResult = await client.query<CopiedStudyQuery, CopiedStudyQueryVariables>({
    query: COPIED_STUDY_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = copiedStudyResult;
  const { study } = data;
  if (_.isNil(study) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return study;
};

export default fetchCopiedStudy;
